module.exports = __webpack_public_path__ + "media/images/admin/icons/gear-gray-76e7f98164119f3c22840e3ed0368589.svg";